import React, {Component} from 'react';
import BannerChar from './BannerChar';
import {Droppable, Draggable} from 'react-beautiful-dnd';

import dividerImg from '../images/vertical-dashed-line.svg';
import menuImg from '../images/menu.svg';

export default class ElkoninBox extends Component {
  renderChar = (model, index, maxHeight, boxes) => {
    return (
      <BannerChar
        key={model.uuid}
        index={index}
        model={model}
        extraStyle={{
          width: this.props.charWidth,
          maxHeight,
        }}
        boxes={boxes}
      />
    );
  };

  dividerStyle(maxItems) {
    let backgroundStyle = '';
    const backgroundTemplate = (xPercent) => `url(${dividerImg}) ${xPercent}% 50% repeat-y`;

    if (maxItems > 1) {
      for (let i = 1; i < maxItems; i += 1) {
        const xPercent = (100 / maxItems) * i;
        backgroundStyle += backgroundTemplate(xPercent);
        if (i !== maxItems - 1) backgroundStyle += ', ';
      }
    }

    return backgroundStyle;
  }

  render() {
    const {index, box, boxes, beingDragged, charWidth, height} = this.props;
    const {uuid, items, maxItems, isScaffolded} = box;
    const widthScale = box.widthScale ?? 1;

    let isDropDisabled = false;
    // Prevent elkonin boxes and clipart from being dropped into an elkonin box
    if (['all-elkonin-boxes', 'clipart'].includes(beingDragged?.source?.droppableId)) isDropDisabled = true;

    // Prevent dropping more letters than spots in the elkonin box
    const draggingModel = beingDragged?.draggableId
      ? boxes[beingDragged.source.droppableId]?.items.find((item) => item.uuid === beingDragged.draggableId)
      : null;
    const draggingLetterCount = draggingModel?.letter?.length ?? 1;
    const itemCount = items.reduce((acc, val) => {
      return acc + (val?.letter?.length ?? 1);
    }, 0);
    if (beingDragged?.source.droppableId !== uuid && draggingLetterCount > maxItems - itemCount) isDropDisabled = true;
    if (box.id === 'spaceBox') isDropDisabled = true;

    return (
      <Draggable draggableId={uuid} index={index}>
        {(provided) => (
          <div
            {...provided.draggableProps}
            ref={provided.innerRef}
            className="designer-elkonin-box-container"
            style={{
              width: charWidth * maxItems * widthScale + 10 + maxItems, // 10 for 2 5px borders
              ...provided.draggableProps.style,
            }}
          >
            <div {...provided.dragHandleProps} className="designer-elkonin-box-header">
              <img src={menuImg} alt="menu" style={{marginLeft: 7, marginRight: 5}} />
            </div>

            <Droppable droppableId={uuid} direction="horizontal" isDropDisabled={isDropDisabled}>
              {(provided) => (
                <div
                  {...provided.droppableProps}
                  className={`designer-elkonin-box${box.id === 'spaceBox' ? ' space-box' : ''}`}
                  ref={provided.innerRef}
                  style={{
                    height,
                    width: charWidth * maxItems * widthScale + maxItems,
                    background: isScaffolded ? this.dividerStyle(maxItems) : null,
                  }}
                >
                  {items.map((char, index) => this.renderChar(char, index, height, boxes))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </div>
        )}
      </Draggable>
    );
  }
}
